import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Input from '../field/input';
import Message from '../field/message';
import { InputWrapper } from '../field/styles';
import { Label } from '../../styled/label';
import { labels } from '../../form/strings';
import { FieldWrapper, DatePartWrapper } from './styles';

const restrictLength = (e) => {
  const { value, name } = e.target;
  const part = name.match(/\[(.*?)\]/)[1]; // Get the date [part] string from the input name
  const maxLengths = {
    day: 2,
    month: 2,
    year: 4,
  };

  return value.slice(0, maxLengths[part]);
};

const DateOfBirth = forwardRef(({ label, name, required }, ref) => (
  <InputWrapper>
    {label && <h3>{label}</h3>}
    <FieldWrapper>
      <DatePartWrapper>
        <Label htmlFor={`${name}[day]`}>{labels.DOB_DAY}</Label>
        <Input
          name={`${name}[day]`}
          ref={ref}
          type="number"
          autoComplete="bday-day"
          required={required}
          cascadeErrorStatus
          min="0"
          max="31"
          onInput={(e) => {
            e.target.value = restrictLength(e);
          }}
          data-input-scroll-id={name}
        />
      </DatePartWrapper>
      <DatePartWrapper>
        <Label htmlFor={`${name}[month]`}>{labels.DOB_MONTH}</Label>
        <Input
          name={`${name}[month]`}
          ref={ref}
          type="number"
          autoComplete="bday-month"
          required={required}
          cascadeErrorStatus
          min="0"
          max="12"
          onInput={(e) => {
            e.target.value = restrictLength(e);
          }}
        />
      </DatePartWrapper>
      <DatePartWrapper>
        <Label htmlFor={`${name}[year]`}>{labels.DOB_YEAR}</Label>
        <Input
          className="year"
          name={`${name}[year]`}
          ref={ref}
          type="number"
          autoComplete="bday-year"
          required={required}
          cascadeErrorStatus
          min="0"
          onInput={(e) => {
            e.target.value = restrictLength(e);
          }}
        />
      </DatePartWrapper>
    </FieldWrapper>

    {/*  this combines  the error messages for the above 3 fields into one element */}
    <Message
      name={name}
      errorMessageFormatter={({ error, form }) => {
        if (error) {
          if (typeof error === 'string') {
            return error;
          }

          if (typeof error === 'object') {
            // only display the first error message for a touched field
            if (
              error._ &&
              form.touched[name] &&
              form.touched[name].day &&
              form.touched[name].month &&
              form.touched[name].year
            ) {
              return error._;
            }

            return Object.keys(error)
              .filter((key) => form.touched[name] && form.touched[name][key])
              .map((key) => error[key])[0];
          }
        }
      }}
    />
  </InputWrapper>
));

DateOfBirth.displayName = 'DateOfBirth';

DateOfBirth.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool,
};

export default DateOfBirth;
